import { RunState } from "types/generated";
import { AccessResult } from "utils/access";
import RunPhaseLogs from "components/Run/elements/RunPhaseLogs";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import StopRunButton from "components/Run/elements/StopRunButton";

import { RunHistoryEntryType } from "../../types";
import { useVisibilityToggle } from "../../hooks/useVisibilityToggle";
type PlanningEntryProps = {
  timestamp: number;
  until: number | null;
  stateVersion: number | null;
  hasLogs: boolean;
  openLogsByDefault: boolean;
  showStopButton: boolean;
  beforeHooks: string[] | undefined;
  afterHooks: string[] | undefined;
  runId: string;
  stackId: string;
  isModuleRun: boolean;
  canStop: AccessResult;
  runQueryToRefetch: string;
};

const PlanningEntry = ({
  timestamp,
  until,
  stateVersion,
  hasLogs,
  openLogsByDefault,
  showStopButton,
  beforeHooks,
  afterHooks,
  runId,
  stackId,
  isModuleRun,
  canStop,
  runQueryToRefetch,
}: PlanningEntryProps) => {
  const [showLogs, toggleLogs] = useVisibilityToggle(openLogsByDefault, hasLogs);

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.Planning}
      timestamp={timestamp}
      until={until}
      isLoading={!until}
      onClick={toggleLogs}
      isOpen={showLogs}
    >
      {showLogs && (
        <RunPhaseLogs
          beforeHooks={beforeHooks}
          afterHooks={afterHooks}
          state={RunState.Planning}
          until={until}
          stateVersion={stateVersion}
          runId={runId}
          stackId={stackId}
          isModuleRun={isModuleRun}
        >
          {showStopButton && (
            <StopRunButton
              canStop={canStop}
              runId={runId}
              stackId={stackId}
              runQueryToRefetch={runQueryToRefetch}
            />
          )}
        </RunPhaseLogs>
      )}
    </HistoryEntryWrapper>
  );
};

export default PlanningEntry;
